export const PATIENT = "patient";
export const UNLISTED_PATIENTS = "unlistedpatients";
export const TREATMENT_REPORT = "treatmentReport";
export const SELECT_CLINIC = "selectclinic";
export const CREATE_REFERRAL = "createReferral"
export const EMERGENCY_TREATMENT = "emergencyTreatment"
export const LISTED_PATIENTS = "listedpatients";
export const REFERRAL = "referral";
export const REFERRAL_TREATMENT_REPORTING = "referralTreatmentReporting";
export const RISK_POT_REPORT = "riskPotReport";
export const RISK_POT_REPORT_WITH_REGISTERED_PRE_ASSESSMENT = "RiskPotReportsWithRegisteredPreAssessment";
export const REFERRAL_SUMMARY = "referralSummary";
export const REFERRAL_MANUAL_REGISTRATION = "referralManualRegistration";
export const REFERRAL_SEARCH = "referralSearch";
export const CHECK_BUDGETS = "checkBudgets";
export const RISK_POT_REPORT_SEARCH = "riskPotReportSearch";
export const ORTHODONTIC_REFERRAL = "orthodonticReferral";
export const ORTHODONTIC_REFERRAL_SEARCH = "orthodonticReferralSearch";
export const ORTHODONTIC_REFERRAL_PROVNINGSKONSULT = "orthodonticReferralProvningskonsult";
export const IMPORTED_XMLS = "importedXmls";
export const EMAIL_SETTING = "emailSetting";
export const ORTHODONTIC_LKGCF_PATIENTS = "orthodonticLkgCfPatients";
export const GENERAL_DENTAL_REFERRAL = "generalDentalReferral";
export const GENERAL_DENTAL_REFERRAL_SEARCH = "generalDentalReferralSearch";
export const INVOICES = "invoices";
export const XML_FILE_TREATMENT_REPORTING = "xmlFileTreatmentReporting";
export const INVOICE = "invoice";
export const UNLISTED_INFANTS = "unlistedinfants";
export const ENDED_LISTINGS = "endedlistings";
export const PATIENT_TREATMENT_SEARCH = "patientTreatmentSearch";
export const PREVENTION_PROGRAM_INFANTS = "preventionProgramInfants";
export const RISK_POT_REPORT_PRE_ASSESSMENT_SEARCH = "riskPotReportPreAssessmentSearch";
export const ORTHODONTIC_LKGCF_PATIENT_EXTENSION = "orthodonticLkgCfPatientExtension";
export const ORTHODONTIC_LKGCF_PATIENT_EXTENSION_SEARCH = "orthodonticLkgCfPatientExtensionSearch";
export const ORTHODONTIC_REFERRAL_ADVANCED_CONSULTATION_NEEDS_FOR_CONSULTATION_DENTAL_GROUP = "orthodonticReferralAdvancedConsultationNeedsForConsultationDentalGroup";
export const ORTHODONTIC_REFERRAL_ADVANCED_CONSULTATION_NEEDS_FOR_JOINT_CONSULTATION_GROUP = "orthodonticReferralAdvancedConsultationNeedsForJointConsultationGroup";
export const EMERGENCY_TREATMENT_SEARCH = "emergencyTreatmentSearch";
export const PATIENTS_REFRAINING_FREE_DENTAL_CARE = "patientsRefrainingFreeDentalCare";
export const ADDITIONAL_ASSIGNMENTS = "additionalAssignments";

export const SILENT_RENEW = "silentRenew";